export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9162.f80e29e0.jpg";